// Generated by ts-to-zod
import { z } from 'zod';

export const queueGetQuerySchema = z
  .object({
    fields: z.array(z.string()),
  })
  .partial();
